import React from 'react';
import { ArrowDown } from 'lucide-react';
const withoutSteps = ['Book creates trust', 'Generic next step', 'Unknown reader', 'Unknown outcome'];
const withSteps = ['Book creates trust', 'Reader finds what applies', 'Takes a useful next move', 'Raises a hand with context', 'Moves toward fitting support'];
function Node({
  label,
  active
}: {
  label: string;
  active: boolean;
}) {
  return <div className={`w-full rounded-xl border px-5 py-4 text-center text-base ${active ? 'border-seaglass bg-white font-medium text-navy shadow-sm' : 'border-gray-200 bg-white/70 text-text-muted'}`} data-id="element-791" data-mp="282nq0egpzi7x">
      {label}
    </div>;
}
function Connector({
  active
}: {
  active: boolean;
}) {
  return <div className="flex justify-center py-1.5" data-id="element-792" data-mp="1u2mn6tgwa0pt">
      <ArrowDown className={`h-4 w-4 ${active ? 'text-seaglass' : 'text-gray-300'}`} aria-hidden="true" data-id="element-793" data-mp="1u1uqtgfh3yyh" />
    </div>;
}

/** Diagram 1 — without / with Reader-to-Revenue System. */
export function GapDiagram() {
  return <div className="grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-794" data-mp="ipah0bxnx60h">
      <div className="flex h-full flex-col rounded-3xl border border-gray-200 bg-paper p-7 md:p-8" data-id="element-795" data-mp="3e8xyahuduvy">
        <span className="mb-6 inline-flex w-fit rounded-full border border-gray-200 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-text-muted" data-id="element-796" data-mp="7drhp2xxfzx7">
          Without a Reader-to-Revenue System
        </span>
        <div className="flex flex-1 flex-col justify-start" data-id="element-797" data-mp="3uhnuu0kevaqe">
          {withoutSteps.map((step, i) => <React.Fragment key={step} data-id="element-798" data-mp="3ft1im7q2yz3e" data-mpi={i}>
              <Node label={step} active={false} data-id="element-799" data-mp="3klb51drzlh0x" />
              {i < withoutSteps.length - 1 && <Connector active={false} data-id="element-800" data-mp="3kn5osoriv33f" />}
            </React.Fragment>)}
        </div>
      </div>

      <div className="flex h-full flex-col rounded-3xl border-2 border-seaglass bg-white p-7 shadow-[0_24px_50px_-28px_rgba(139,168,159,0.7)] md:p-8" data-id="element-801" data-mp="36rtlhszaw4aw">
        <span className="mb-6 inline-flex w-fit rounded-full bg-seaglass px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-white" data-id="element-802" data-mp="2wwru0qhjyq55">
          With a Reader-to-Revenue System
        </span>
        <div className="flex flex-1 flex-col justify-start" data-id="element-803" data-mp="2ir9oo7zykbck">
          {withSteps.map((step, i) => <React.Fragment key={step} data-id="element-804" data-mp="2dz83txoq5cax" data-mpi={i}>
              <Node label={step} active={true} data-id="element-805" data-mp="2dy6ubxncwxvb" />
              {i < withSteps.length - 1 && <Connector active={true} data-id="element-806" data-mp="2916p1oybzz59" />}
            </React.Fragment>)}
        </div>
      </div>
    </div>;
}